/* eslint-disable */

import Sloth from '../Sloth';
import $ from 'jquery';
import "./index.scss"

@Sloth.component({
    defaultOptions : {
        placeholder : '请选择',
    }
})

export default class Dropdown {

    constructor() {
        this.value = "";
        this.label = "";
        this.open = false;
    }

    get popperDom() {
        return $(".Dropdown-popper", this.dom)
    }

    get labelDom() {
        return $(".Dropdown-label", this.dom)
    }

    get inputDom() {
        return $("input:hidden", this.dom)
    }

    onInit() {
        const dom = this.dom;
        const options = this.options;

        $(dom).on("click", ".Dropdown-data", (e) => {
            this.value = $(e.target).data('value')
            this.label = $(e.target).text()
            this.open = false;
            this.render()
            $(this.dom).trigger('change', [this.value, this.label]);
        })

        $(dom).on("click", ".Dropdown-label", (e) => {
            this.open = !this.open;
            this.render()
        })

        $(document).on("click", (e) => {
            if($(e.target).parents(".Dropdown").length === 0){
                this.open = false;
                this.render()
            }
        })

        this.render()
    }

    render() {
        this.inputDom.val(this.value);
        this.labelDom.text(this.label || this.options.placeholder || "");

        if(this.open) {
            $(this.dom).addClass("open")
        } else {
            $(this.dom).removeClass("open")
        }
    }
}




/** WEBPACK FOOTER **
 ** ./components/Dropdown/index.js
 **/